export default {
  path: "/app/interactive-form",
  name: "interactive-form",
  redirect: "/app/interactive-form/all",
  component: () => import("./layout"),
  children: [
    {
      name: "allListInteractiveForm",
      path: "/app/interactive-form/all",
      component: () => import("./my-list.vue"),
      meta: {
        appName: "allListInteractiveForm",
        detail: "detailInteractiveForm",
        edit: "editInteractiveForm",
        props: {
          type: "ALL",
        },
      },
      children: [
        {
          name: "detailInteractiveForm",
          path: "/app/interactive-form/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "allListInteractiveForm",
            showRight: true,
            appName: "allListInteractiveForm",
            edit: "editInteractiveForm",
          },
        },
        {
          name: "editInteractiveForm",
          path: "/app/interactive-form/:id/edit",
          component: () => import("./edit-view.vue"),
          meta: {
            listName: "allListInteractiveForm",
            showRight: true,
            appName: "allListInteractiveForm",
            detail: "detailInteractiveForm",
          },
        },
      ],
    },
    {
      name: "sentToMeListInteractiveForm",
      path: "/app/interactive-form/sent-to-me",
      component: () => import("./sent-to-me.list.vue"),
      meta: {
        appName: "sentToMeListInteractiveForm",
        detail: "detailSentToMeInteractiveForm",
        props: {
          type: "SENT_TO_ME",
        },
      },
      children: [
        {
          name: "detailSentToMeInteractiveForm",
          path: "/app/interactive-form/sent-to-me/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "sentToMeListInteractiveForm",
            showRight: true,
            appName: "sentToMeListInteractiveForm",
            detail: "detailSentToMeInteractiveForm",
          },
        },
      ],
    },
    {
      name: "myListInteractiveForm",
      path: "/app/interactive-form/created-by-me",
      component: () => import("./created-by-me.list.vue"),
      meta: {
        appName: "myListInteractiveForm",
        detail: "detailMyListInteractiveForm",
        edit: "editMyListInteractiveForm",
        props: {
          type: "CREATED_BY_ME",
        },
      },
      children: [
        {
          name: "detailMyListInteractiveForm",
          path: "/app/interactive-form/created-by-me/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "myListInteractiveForm",
            showRight: true,
            appName: "myListInteractiveForm",
            edit: "editMyListInteractiveForm",
            detail: "detailMyListInteractiveForm",
          },
        },
        {
          name: "editMyListInteractiveForm",
          path: "/app/interactive-form/created-by-me/:id/edit",
          component: () => import("./edit-view.vue"),
          meta: {
            listName: "myListInteractiveForm",
            showRight: true,
            appName: "myListInteractiveForm",
            detail: "detailMyListInteractiveForm",
            edit: "editMyListInteractiveForm",
          },
        },
      ],
    },
    {
      name: "myListDraftInteractiveForm",
      path: "/app/interactive-form/my-draft",
      component: () => import("./draft-created-by-me.list.vue"),
      meta: {
        appName: "myListDraftInteractiveForm",
        edit: "editMyListDraftInteractiveForm",
        props: {
          type: "MY_DRAFT",
        },
      },
      children: [
        {
          name: "editMyListDraftInteractiveForm",
          path: "/app/interactive-form/my-draft/:id/edit",
          component: () => import("./edit-view.vue"),
          meta: {
            listName: "myListDraftInteractiveForm",
            showRight: true,
            appName: "myListDraftInteractiveForm",
            edit: "editMyListDraftInteractiveForm",
          },
        },
      ],
    },
    {
      name: "hrBcListInteractiveForm",
      path: "/app/interactive-form/hr-bc",
      component: () => import("./hr-cb.list.vue"),
      meta: {
        appName: "hrBcListInteractiveForm",
        detail: "detailHrBcInteractiveForm",
        props: {
          type: "MY_DRAFT",
        },
      },
      children: [
        {
          name: "detailHrBcInteractiveForm",
          path: "/app/interactive-form/hr-bc/:id/detail",
          component: () => import("./detail-view.vue"),
          meta: {
            listName: "hrBcListInteractiveForm",
            showRight: true,
            appName: "hrBcListInteractiveForm",
            detail: "detailHrBcInteractiveForm",
          },
        },
      ],
    },
  ],
};
